import { Typography } from 'antd'

const { Title } = Typography

export default function BestPractices() {
  return <>
    <Title level={2}>Best Practices</Title>
    
  </>
}